import { useMeasureAssociation } from '~/services';
import React from 'react';

interface MedicationsIconProps {
    code: string;
}

export function MedicationsIcon({ code }: MedicationsIconProps) {
    const measureAssociations = useMeasureAssociation(code);

    if (!Array.isArray(measureAssociations) || measureAssociations.length === 0) {
        return null;
    }
    return (
        <button type="button" className="medications-icon">
            <i className="fa-solid fa-medkit" title="Medication Association">
                <span className="sr-only">Medication Association</span>
            </i>
        </button>
    );
}
